@let s = server();

<app-card-shell [title]="s.type | gameTitle" [online]="s.online" [navItems]="navItems()">
  <picture card-image style="image-rendering: pixelated">
    <source type="image/avif" [srcset]="avifSrcset('/assets/img/games/' + s.type)" [sizes]="topImageSizes" />
    <img
      class="card-img-top"
      priority
      fill
      draggable="false"
      ngSrc="/assets/img/games/{{ s.type }}.webp"
      [sizes]="topImageSizes"
      alt="Artistic image for the game {{ s.type }}." />
  </picture>

  <h3 ngbTooltip="{{ s.urls?.connect ? s.urls!.connect : '' }}" class="fs-5 card-title">
    {{ s.name }}
  </h3>
  <div class="badges mb-0">
    <span
      class="badge rounded-pill"
      ngbTooltip="This server is currently {{ s.online ? 'online' : 'offline' }}"
      [ngClass]="{
        'bg-success': s.online,
        'bg-secondary': !s.online,
      }">
      {{ s.online ? 'Online' : 'Offline' }}
    </span>
    @if (s.online && s.players) {
      @let onlineText = s.players.online ?? '?';
      @let maxText = s.players.max === -1 ? '∞' : (s.players.max ?? '?');
      <span
        class="badge rounded-pill bg-primary ms-1"
        ngbTooltip="There are currently {{ onlineText }} out of maximum {{ maxText }} players online.">
        {{ onlineText }} / {{ maxText }}
      </span>
    }
  </div>

  @if ((s.players?.list?.length ?? 0) > 0) {
    <div class="card-text">
      Online Players:
      <ul>
        @for (player of s.players?.list; track player) {
          <li>{{ player }}</li>
        }
      </ul>
    </div>
  }
  <small card-footer class="text-muted">Version: {{ s.version || 'Unknown' }}</small>
</app-card-shell>
